import { Slide } from "@jelly/lesson";

import environment from "./components/environment";
import reproduction from "./components/reproduction";
import measurement from "./components/measurement";
import data from "./components/data";

const principle: Slide = {
  title: "Listening Experiment",
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [
            { name: "Environment" },
            { name: "Reproduction system" },
            { name: "Measurement" },
            { name: "Data analysis" },
          ],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [[], [], [], []],
      components: [environment, reproduction, measurement, data],
    },
  },
};

export default principle;
